import React, { useEffect, useState } from "react";
import {
  getResourceRequestedDealsData,
} from "../../services/Apis";
import {
  message,
  Result,
  Select,
  Skeleton,
} from "antd";
import LogoutPopUp from "../../components/LogoutPopUp";
import DealResourceRequestInfo from "../components/DealResourceRequestInfo";

export default function ResourceRecommendation() {
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);

  const hasAccess = JSON.parse(
    localStorage.getItem("user_details") as string
  ).features.includes("AUDIT_RESOURCE_CHANGES");

  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [allResourcesData, setAllResourcesData] = useState<any[]>([]);

  const [selectedDealId, setSelectedDealId] = useState<string>("");

  useEffect(() => {
    if (hasAccess) {
      setPageLoading(true);
      getResourceRequestedDealsData()
        .then((resp) => {
          setPageLoading(false);
          const errorStatus =
            (resp as any).error_status ?? (resp as any).status;
          const errorMsg = (resp as any).error ?? (resp as any).data?.error;

          if (errorStatus === 401) {
            setTokenExpired(true);
          }
          if (errorMsg) {
            message.error(errorMsg);
            return;
          }
          if ("data" in resp) {
            setAllResourcesData(resp.data);
          }
        })
        .catch((error) => {
          setPageLoading(false);
          message.error("Failed to Get Resource Request Data");
        });
    }
  }, []);



  return (
    <>
      {tokenExpired ? (
        <LogoutPopUp openPopup={tokenExpired} />
      ) : (
        <>
          {hasAccess ? (
            <>
              {pageLoading ? (
                <Skeleton
                  active
                  paragraph={{ rows: 8 }}
                  style={{ minHeight: "80vh" }}
                />
              ) : (
                <div style={{ minHeight: "80vh" }}>
                  <div>
                    <h1 style={{ fontSize: "20px" }}>Resource Requests</h1>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                  >
                    <Select
                      showSearch
                      placeholder="HubSpot Deal"
                      style={{ width: "100%" }}
                      filterOption={(input, option: any) =>
                        option?.children
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onSelect={(value) => setSelectedDealId(value)}
                      // disabled={JSON.parse(localStorage.getItem('user_details') as string).features.includes('FE_CREATE_PRICING') ? false : true}
                    >
                      {allResourcesData.map((option, index) => {
                        return (
                          <Select.Option key={index} value={option.deal_id}>
                            {option.client_name +
                              " | " +
                              option.deal_name +
                              " | " +
                              option.deal_id}
                          </Select.Option>
                        );
                      })}
                    </Select>

                    {selectedDealId && <DealResourceRequestInfo dealData={allResourcesData.find(item => item.deal_id === selectedDealId)} />}
                  </div>
                </div>
              )}
            </>
          ) : (
            <Result status="403" title="403" subTitle="Sorry, you are not authorized to access this page." />
          )}
        </>
      )}
    </>
  );
}
